import { render, staticRenderFns } from "./homeFoot.vue?vue&type=template&id=74afa3a6&scoped=true"
import script from "./homeFoot.vue?vue&type=script&lang=js"
export * from "./homeFoot.vue?vue&type=script&lang=js"
import style0 from "./homeFoot.vue?vue&type=style&index=0&id=74afa3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74afa3a6",
  null
  
)

export default component.exports